import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE = process.env.REACT_APP_API_URL;

export const fetchBookingFlights = createAsyncThunk(
  "bookingFlights/fetchBookingFlights",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE}/ticketing/booking_flights`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.getItem("access")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const bookingFlightsSlice = createSlice({
  name: "bookingFlights",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    invalidateBookingFlights: (state) => {
      state.data = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookingFlights.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookingFlights.fulfilled, (state, action) => {
        state.loading = false;
        state.data = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchBookingFlights.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { invalidateBookingFlights } = bookingFlightsSlice.actions;
export default bookingFlightsSlice.reducer;
